export function formData(data) {
    const form = new FormData();
    const entries = Object.entries(data !== null && data !== void 0 ? data : {});
    for (const [key, value] of entries) {
        if (value == null)
            continue;
        form.append(key, value);
    }
    return form;
}
//# sourceMappingURL=openapi.js.map